import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import {
  ChannelType,
  EChannelPlatform,
  SubscriblySubChannel,
} from '@doddly/core';

@Component({
  selector: 'ly-sub-channels-dropdown',
  standalone: true,
  imports: [CommonModule, FormsModule, DropdownModule, ProgressSpinnerModule],
  templateUrl: './sub-channels-dropdown.component.html',
  styleUrl: './sub-channels-dropdown.component.scss',
})
export class SubChannelsDropdownComponent {
  @Input() subChannels: SubscriblySubChannel[] = [];
  @Input() selectedSubChannelId: string | null = null;
  @Input() platform: ChannelType | undefined = undefined;
  @Input() disabled = false;
  @Input() loading = false;
  @Output() subChannelChange = new EventEmitter<string>();
  @Output() refresh = new EventEmitter<void>();

  readonly EChannelPlatform = EChannelPlatform;

  get showRefreshFooter(): boolean {
    return this.platform === EChannelPlatform.pinterest;
  }

  onSubChannelChange(event: { value: string }): void {
    this.subChannelChange.emit(event.value);
  }

  onRefresh(event: Event): void {
    event.preventDefault();
    event.stopPropagation();

    if (this.disabled || this.loading) {
      return;
    }

    this.refresh.emit();
  }

  get placeholder(): string {
    return this.platform === EChannelPlatform.pinterest
      ? 'Select a Board'
      : 'Select a sub-channel';
  }
}
